let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eZKm4")).then(() => parcelRequire('cnifX'));